// Animated walking sprite for UI (lab, onboarding look picker, profile).
import { useEffect, useRef } from "preact/hooks";
import type { AvatarIdentity } from "@degen/sim/avatar/traits";
import { FRAME_H, FRAME_W } from "../avatar/sprite";
import { avatarCanvas } from "../avatar/canvas";

/** `dir` null = cycle front, right, back, left. */
export function SpriteWalker({ av, dir = null, scale = 4, walking = true }: { av: AvatarIdentity; dir?: number | null; scale?: number; walking?: boolean }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const sheet = avatarCanvas(av);
    const ctx = ref.current!.getContext("2d")!;
    ctx.imageSmoothingEnabled = false;
    let raf = 0;
    const start = performance.now();
    const draw = (now: number) => {
      const t = (now - start) / 1000;
      const d = dir ?? [0, 2, 3, 1][Math.floor(t / 1.6) % 4];
      const frame = walking ? Math.floor(t * 7) % 4 : 0;
      ctx.clearRect(0, 0, FRAME_W * scale, FRAME_H * scale);
      ctx.drawImage(sheet, frame * FRAME_W, d * FRAME_H, FRAME_W, FRAME_H, 0, 0, FRAME_W * scale, FRAME_H * scale);
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [av, dir, scale, walking]);
  return <canvas ref={ref} width={FRAME_W * scale} height={FRAME_H * scale} class="sprite-walker" />;
}
